<template>
  <div>
    <b-alert
      variant="success"
      :show="showAlert_success"
      @dismissed="showAlert_success = false"
      >{{ alert_success_message }}</b-alert
    >

    <b-alert
      variant="danger"
      :show="showAlert_error"
      @dismissed="showAlert_error = false"
      >{{ alert_error_message }}</b-alert
    >

    <b-container fluid>
      <h3 class="mt-3 mb-3">Redemption Status</h3>

      <b-card class="mb-3">

        <div class="search_bar mb-3">
          <b-row>
            <b-col cols="2" class="pr-1">
              <b-form-select
                size="sm"
                v-model="search_criteria.status_selected"
                :options="status_options"
              />
            </b-col>
            <!-- <b-col cols="2" class="pl-0 pr-1">
              <b-form-select
                size="sm"
                v-model="search_criteria.case_created_by"
                :options="search_user_options"
              />
            </b-col> -->
            <b-col cols="3" class="pl-0 pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="text"
                placeholder="Order#/Tracking#/Attention/Phone"
                v-model="search_criteria.keyword"
              ></b-form-input>
            </b-col>
            <!-- <b-col cols="2" class="pl-0 pr-1">
              <b-form-checkbox
                id="chk-has_delivery_case"
                v-model="search_criteria.has_delivery_case"
                name="chk-has_delivery_case"
                size="sm"
                value="true"
                unchecked-value="false"
              >
                Has Delivery Case
              </b-form-checkbox>
              <b-form-checkbox
                id="chk-has_cs_case"
                v-model="search_criteria.has_cs_case"
                name="chk-has_cs_case"
                size="sm"
                value="true"
                unchecked-value="false"
              >
                Has CS Issue
              </b-form-checkbox>
            </b-col> -->
            <b-col class="text-left p-0">
              <b-button
                class="btn-action"
                size="sm"
                variant="info"
                @click="onSearch"
              >
                <font-awesome-icon class="mr-1" icon="search" />Search
              </b-button>

              <b-button
                class="btn-action"
                size="sm"
                variant="info"
                @click="exportCSV"
              >
                Export
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-card>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>

      <b-table
        responsive
        small
        outlined
        striped
        hover
        :items="items"
        :fields="fields"
        :tbody-tr-class="rowClass"
      >
        <template v-slot:head(chk_box)="data">
          <b-form-checkbox
            size="sm"
            plain
            id="chkbox_all"
            value="all"
            v-model="check_all_rows"
          ></b-form-checkbox>
        </template>
        <template v-slot:cell(chk_box)="data">
          <b-form-checkbox
            size="sm"
            class="chkbox_row"
            plain
            :id="'chkbox_row_' + data.index"
            v-model="data.item.is_checked"
          ></b-form-checkbox>
        </template>
        <template v-slot:cell(status)="data">
          {{ data.item.status }}
          <span v-if="data.item.status_reason"
            >- {{ data.item.status_reason }}</span
          >
          <span v-if="data.item.other_reason">
            <br />
            [{{ data.item.other_reason }}]
          </span>
        </template>

        <template v-slot:cell(attention)="data">
          <span v-if="!data.item.attention_driver">{{
            data.item.attention
          }}</span>
          <span v-if="data.item.attention_driver">{{
            data.item.attention_driver
          }}</span>
        </template>

        <template v-slot:cell(phone)="data">
          <span v-if="!data.item.phone_driver">{{ data.item.phone }}</span>
          <span v-if="data.item.phone_driver">{{
            data.item.phone_driver
          }}</span>
        </template>

        <template v-slot:cell(carried_by)="data">
          <span v-if="data.item.carried_by && data.item.carried_by != ''">
            <span v-if="$store.state.user_obj.account_type != 'young_living'">
              {{ data.item.carried_by }}
            </span>
            <span v-if="$store.state.user_obj.account_type == 'young_living'">
              <span v-if="data.item.carried_by_type == 'driver'">
                Driver
              </span>
              <span v-if="data.item.carried_by_type != 'driver'">
                {{ data.item.carried_by_name }}
              </span>
            </span>
          </span>
        </template>

        <template v-slot:cell(pod_image)="data">
          <!-- <a
            v-if="data.item.pod_image"
            :href="data.item.pod_image"
            target="_blank"
          >{{data.item.pod_type}}</a>-->
          <div style="text-align:center;">
            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              v-if="data.item.pod_image"
              @click="showPod(data.item)"
              >{{ data.item.pod_type }}</b-button
            >
            <span v-if="!data.item.pod_image">/</span>
          </div>
        </template>

        <template v-slot:cell(schedule_date)="data">
          <span v-if="!data.item.reschedule_delivery_date">{{
            displayDate(data.item.schedule_date)
          }}</span>
          <span v-if="data.item.reschedule_delivery_date"
            >{{ data.item.reschedule_type }}
            {{ displayDate(data.item.reschedule_delivery_date) }}</span
          >
        </template>

        <template v-slot:cell(action)="data">
          <b-button
            class="btn-action"
            size="sm"
            variant="info"
            :to="{ name: 'tracking_detail', params: { id: data.item.id } }"
            >Detail</b-button
          >

          <b-button
            class="btn-action"
            size="sm"
            variant="info"
            @click.stop="reserveLocation(data.item)"
            >Reserve</b-button
          >

          <b-button
            class="btn-action"
            size="sm"
            variant="info"
            @click.stop="printRedemptionWB(data.item)"
            >Print</b-button
          >

          <span
            v-if="
              $store.state.user_obj.account_type == 'admin' ||
                $store.state.user_obj.account_type == 'cs'
            "
          >
            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              @click.stop="returnTracking(data.item)"
            >
              <font-awesome-icon class="mr-1" icon="undo" />Returned
            </b-button>

            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              @click.stop="showModal_reschedule_tracking(data.item)"
            >
              <font-awesome-icon class="mr-1" icon="calendar-alt" />Reschedule
            </b-button>

            <b-button
              v-if="data.item.status != 'cancel'"
              class="btn-action"
              size="sm"
              variant="danger"
              @click.stop="showModal_cancelTracking(data.item)"
              >Cancel</b-button
            >

            <b-button
              v-if="data.item.status == 'cancel' || data.item.status == 'hold'"
              class="btn-action"
              size="sm"
              variant="danger"
              @click.stop="pendingTracking(data.item)"
              >Pending</b-button
            >

            <b-button
              v-if="data.item.status != 'hold'"
              class="btn-action"
              size="sm"
              variant="danger"
              @click.stop="showModal_holdTracking(data.item)"
              >Hold</b-button
            >
          </span>
        </template>
      </b-table>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>

      <b-modal ref="modal_cancelTracking" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Tracking#: {{ updating_item.tracking_number }}</b-col>
          </b-row>

          <b-row>
            <b-col>
              <label>Cancel Reason:</label>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-form-input
                id="input-small"
                size="sm"
                type="text"
                placeholder="Remark"
                v-model="updating_item.remark"
              ></b-form-input>
            </b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_cancelTracking"
            >Cancel</b-btn
          >
          <b-btn
            class="mt-3"
            variant="outline-success"
            @click="cancelTracking()"
            >Confirm</b-btn
          >
        </div>
      </b-modal>

      <b-modal ref="modal_reschedule_tracking" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Tracking#: {{ updating_item.tracking_number }}</b-col>
          </b-row>

          <b-row>
            <b-col>
              <label>Reschedule:</label>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="auto" class="pr-0">
              <b-form-radio-group
                id="btnradios2"
                buttons
                button-variant="outline-info"
                v-model="reschedule_type_selected"
                :options="reschedule_type_options"
                name="radioBtnOutline"
              />
            </b-col>
            <b-col class="pl-1">
              <b-form-input
                id="reschedule_delivery_date"
                type="date"
                v-model="reschedule_date"
              ></b-form-input>
            </b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_reschedule_tracking"
            >Cancel</b-btn
          >
          <b-btn
            class="mt-3"
            variant="outline-success"
            @click="rescheduleTracking()"
            >Confirm</b-btn
          >
        </div>
      </b-modal>

      <b-modal ref="modal_holdTracking" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Tracking#: {{ updating_item.tracking_number }}</b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_holdTracking"
            >Cancel</b-btn
          >
          <b-btn class="mt-3" variant="outline-success" @click="holdTracking()"
            >Confirm</b-btn
          >
        </div>
      </b-modal>

      <b-modal ref="modal_printWaybill" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-1">
            <b-col>Tracking#: {{ print_item.tracking_number }}</b-col>
          </b-row>

          <b-row class="mb-3">
            <b-col>
              <b-form-select
                size="sm"
                v-model="print_item.no_of_waybill"
                :options="no_of_waybill_options"
              />
            </b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_printWaybill"
            >Cancel</b-btn
          >
          <b-btn class="mt-3" variant="outline-success" @click="printWaybill()"
            >Download</b-btn
          >
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields = [
  {
    key: "tracking_number",
    label: "Tracking#"
  },
  {
    key: "status",
    label: "Status"
  },
  {
    key: "created_at",
    label: "Date"
  },
];

export default {
  name: "Trackings",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      courier_options: [],
      export_date: {
        start_at: moment()
          .subtract(7, "d")
          .format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD")
      },
      upload_file: [],
      upload_file_tracking: [],
      loader_full: false,
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      manual_return_tracking_number: "",
      updating_item: false,
      export_criteria: {
        courier_selected: null,
        status_selected: null
      },
      search_criteria: {
        keyword: "",
        status_selected: null,
        case_created_by: null,
        has_delivery_case: false,
        has_cs_case: false
      },
      status_options: [
        {
          value: null,
          text: "All Status"
        },
        {
          value: "Non-successful",
          text: "Non-successful"
        },
        {
          value: "processed",
          text: "Processed"
        },
        {
          value: "pending",
          text: "Pending"
        },
        {
          value: "in_transit",
          text: "In-Transit"
        },
        {
          value: "successful",
          text: "Successful Delivery"
        },
        {
          value: "returned_to_warehouse",
          text: "Returned to Warehouse"
        },
        {
          value: "return_to_warehouse",
          text: "Returning to Warehouse"
        },
        {
          value: "reschedule",
          text: "Reschedule"
        },
        {
          value: "unreach",
          text: "Unreach"
        },
        {
          value: "reject",
          text: "Reject"
        },
        {
          value: "delay",
          text: "Delay"
        },
        {
          value: "other",
          text: "Other"
        }
      ],
      reschedule_type_selected: "before",
      reschedule_type_options: [
        {
          value: "before",
          text: "before"
        },
        {
          value: "on",
          text: "on"
        },
        {
          value: "after",
          text: "after"
        }
      ],
      reschedule_date: moment().format("YYYY-MM-DD"),
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message: "",

      search_user_options: [],
      check_all_rows: false,

      print_item: {},
      no_of_waybill_options: [
        {
          value: 1,
          text: "1"
        },
        {
          value: 2,
          text: "2"
        },
        {
          value: 3,
          text: "3"
        },
        {
          value: 4,
          text: "4"
        },
        {
          value: 5,
          text: "5"
        }
      ]
    };
  },
  async created() {
    await this.redemption_log_get();
    await this.getCouriers();
    await this.getYLUsers();
    this.initialized = true;
  },
  mounted() {
    // $('#summernote').summernote();
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  watch: {
    // whenever changes, this function will run
    check_all_rows: function(new_val, old_val) {
      // this.check_all_rows = !this.check_all_rows;
      console.log("check_all_rows");
      if (new_val == "all") {
        // Check all
        for (let i in this.items) {
          this.items[i].is_checked = true;
        }
      } else {
        for (let i in this.items) {
          this.items[i].is_checked = false;
        }
      }
      console.log(this.items);
    }
  },
  methods: {
    holdTracking() {
      this.updateTracking(
        this.updating_item,
        "hold",
        null,
        null,
        this.updating_item.remark
      );
    },

    showModal_holdTracking(item) {
      this.updating_item = item;
      this.$refs.modal_holdTracking.show();
    },

    hideModal_holdTracking() {
      this.$refs.modal_holdTracking.hide();
    },

    showModal_printWaybill(item) {
      this.print_item = item;
      this.print_item.no_of_waybill = 1;
      this.printWaybill();
    },

    hideModal_printWaybill() {
      this.$refs.modal_printWaybill.hide();
    },

    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async redemption_log_get() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "redemption_log_get.php",
        data: {
          tracking_number: this.$route.params.tracking_number,
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: this.search_criteria,
          courier_short_name : '7-11',
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id
        }
      });
      this.items = response.data.redemption_logs;
      this.total_rows = parseInt(response.data.total_rows);
      this.loader.hide();
    },

    async getCouriers() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "couriers_get.php",
        data: {}
      });

      this.courier_options = [
        {
          value: null,
          text: "All Couriers"
        }
      ];

      for (let i in response.data.couriers) {
        let courier_obj = {
          value: response.data.couriers[i].short_name,
          text: response.data.couriers[i].long_name
        };

        this.courier_options.push(courier_obj);
      }
    },
    async onImportTrackingNum() {
      // console.log(this.upload_file);
      // return;
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file_tracking);
      formData.append("user_id", this.$store.state.user_obj.user_id);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_courier_import.php",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: formData
      });
      console.log(response);
      if (response) {
        this.loader_full.hide();
        // alert("Upload success");
        // window.location.reload();
      }
    },
    async onUploadFile() {
      // console.log(this.upload_file);
      // return;
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file);
      formData.append("user_id", this.$store.state.user_obj.user_id);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_import.php",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: formData
      });
      console.log(response);
      if (response) {
        this.loader_full.hide();
        // alert("Upload success");
        // window.location.reload();
      }
    },

    onSearch() {
      this.table_offset = 0;
      this.redemption_log_get();
    },

    downloadExcel() {
      let export_url =
        "https://tracking.gols.com.hk/driver/export/gols_tracking_bulk.xlsx";
      window.open(export_url, "_blank");
    },

    exportCSV() {
      // let export_url =
      //   "http://gols.innothink-tech.com/gols/GOLS_Driver_CMS_dev/api/tracking_export.php?";
      // let export_url = "https://tracking.gols.com.hk/driver/api/tracking_export.php?";
      // let export_url = process.env.TRACKING_EXPORT_URL;
      let export_url = process.env.NODEJS_API_URL + "/export_tracking?";
      export_url += "start_at=" + this.export_date.start_at;
      export_url += "&end_at=" + this.export_date.end_at;
      export_url += "&courier_name=" + this.export_criteria.courier_selected;
      window.open(export_url, "_blank");
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.TABLE_LIMIT;
      this.redemption_log_get();
    },

    showModal_reschedule_tracking(item) {
      this.updating_item = item;
      this.reschedule_type_selected = "before";
      this.reschedule_date = moment().format("YYYY-MM-DD");
      this.$refs.modal_reschedule_tracking.show();
    },

    hideModal_reschedule_tracking() {
      this.$refs.modal_reschedule_tracking.hide();
    },

    returnTracking(item) {
      this.updateTracking(
        item,
        "returned_to_warehouse",
        null,
        null,
        item.remark
      );
    },

    cancelTracking() {
      this.updateTracking(
        this.updating_item,
        "cancel",
        null,
        null,
        this.updating_item.remark
      );
    },

    showModal_cancelTracking(item) {
      this.updating_item = item;
      this.$refs.modal_cancelTracking.show();
      // this.updateTracking(item.tracking_number, "Cancelled", null, null);
    },

    hideModal_cancelTracking() {
      this.$refs.modal_cancelTracking.hide();
    },

    rescheduleTracking() {
      this.updateTracking(
        this.updating_item,
        "reschedule",
        this.reschedule_type_selected,
        this.reschedule_date
      );
    },

    pendingTracking(item) {
      this.updateTracking(item, "pending", null, null);
    },

    onManualReturnToWarehouse() {
      this.updateTracking(
        {
          id: this.manual_return_tracking_number,
          tracking_number: this.manual_return_tracking_number,
          by_tracking_number: true
        },
        "returned_to_warehouse",
        null,
        null
      );
    },

    async updateTracking(
      tracking_obj,
      status,
      reschedule_delivery_type,
      reschedule_delivery_date,
      remark
    ) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_update.php",
        data: {
          id: tracking_obj.id,
          status: status,
          reschedule_type: reschedule_delivery_type,
          reschedule_delivery_date: reschedule_delivery_date,
          other_reason: remark,
          user_id: this.$store.state.user_obj.user_id,
          by_tracking_number: tracking_obj.by_tracking_number
        }
      });

      if (response.data.status == "success") {
        this.alert_success_message = `Tracking #${tracking_obj.tracking_number} Update Successfully.`;
        this.showAlert_success = true;
        setTimeout(() => {
          this.showAlert_success = false;
          this.alert_success_message = "";
        }, 3000);
        this.redemption_log_get();
      } else {
        this.alert_error_message = `Tracking #${tracking_obj.id} not found.`;
        this.showAlert_error = true;
        setTimeout(() => {
          this.showAlert_error = false;
          this.alert_error_message = "";
        }, 3000);
      }

      this.$refs.modal_reschedule_tracking.hide();
      this.$refs.modal_cancelTracking.hide();
    },

    async showPod(item) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_pod_get.php",
        data: {
          tracking_id: item.id,
          tracking_number: item.tracking_number
        }
      });

      item.order_ids = response.data.order_ids;
      item.pod_at = response.data.pod_at;

      this.$eventHub.$emit("show_image_view", {
        image_url: item.pod_image,
        order_ids: item.order_ids,
        pod_at: item.pod_at
      });
    },

    async getYLUsers() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "user_get.php",
        data: {
          account_type: "young_living"
        }
      });
      // this.yl_users = response.data.users;
      this.search_user_options = [
        {
          value: null,
          text: "All Users"
        }
      ];
      for (let i in response.data.users) {
        let tmp_user = response.data.users[i];
        this.search_user_options.push({
          value: tmp_user.name,
          text: tmp_user.name
        });
      }
      this.loader.hide();
    },

    async bulkDownloadWaybill() {
      let checked_items = [];
      let waybill_tracking_number = "";

      for (let i in this.items) {
        let item_tmp = this.items[i];
        console.log(item_tmp);
        if (
          item_tmp.is_checked &&
          item_tmp.tracking_number &&
          item_tmp.tracking_number != ""
        ) {
          waybill_tracking_number = item_tmp.tracking_number;
          checked_items.push(item_tmp.tracking_number);
        }
      }

      this.$http({
        url: process.env.NODEJS_API_URL_PDF + "/gen_pdf",
        method: "POST",
        data: {
          ids: checked_items,
          print_packing: false,
          print_waybill: true,
          no_of_waybill: 1
        },
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "waybill.pdf");
        document.body.appendChild(link);
        link.click();
      });
    },

    async bulkDownloadPacking() {
      let checked_items = [];
      let waybill_tracking_number = "";

      for (let i in this.items) {
        let item_tmp = this.items[i];
        console.log(item_tmp);
        if (
          item_tmp.is_checked &&
          item_tmp.tracking_number &&
          item_tmp.tracking_number != ""
        ) {
          waybill_tracking_number = item_tmp.tracking_number;
          checked_items.push(item_tmp.tracking_number);
        }
      }

      this.$http({
        url: process.env.NODEJS_API_URL_PDF + "/gen_pdf",
        method: "POST",
        data: {
          ids: checked_items,
          print_packing: true,
          print_waybill: false,
          no_of_waybill: 1
        },
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "packing.pdf");
        document.body.appendChild(link);
        link.click();
      });
    },

    async bulkDownloadFulfill() {
      let checked_items = [];
      let waybill_tracking_number = "";

      for (let i in this.items) {
        let item_tmp = this.items[i];
        console.log(item_tmp);
        if (
          item_tmp.is_checked &&
          item_tmp.tracking_number &&
          item_tmp.tracking_number != ""
        ) {
          waybill_tracking_number = item_tmp.tracking_number;
          checked_items.push(item_tmp.tracking_number);
        }
      }

      this.$http({
        url: process.env.NODEJS_API_URL_PDF + "/gen_pdf",
        method: "POST",
        data: {
          ids: checked_items,
          print_packing: true,
          print_waybill: true,
          no_of_waybill: 1
        },
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "fulfill.pdf");
        document.body.appendChild(link);
        link.click();
      });
    },

    async printWaybill() {
      let checked_items = [];
      checked_items.push(this.print_item.tracking_number);

      this.$http({
        url: process.env.NODEJS_API_URL_PDF + "/gen_pdf",
        method: "POST",
        data: {
          ids: checked_items,
          print_packing: false,
          print_waybill: true,
          no_of_waybill: this.print_item.no_of_waybill
        },
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "waybill.pdf");
        document.body.appendChild(link);
        link.click();

        this.hideModal_printWaybill();
      });
    },

    async printRedemptionWB(row_item) {
      
      this.$http({
        url: this.NODEJS_API_URL + "/redemption_waybill",
        method: "POST",
        data: {
          ids: [row_item.tracking_number],
          print_packing: false,
          print_waybill: true,
          no_of_waybill: 1
        },
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "waybill.pdf");
        document.body.appendChild(link);
        link.click();

        this.hideModal_printWaybill();
      });
    },

    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.is_checked) return "table-info";
    },

    async reserveLocation(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "redemption_reserve.php",
        data: {
          tracking_number: row_data.tracking_number,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success"
      });
      this.getOrderMaster();
    },
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/RedemptionLogs.vue